import axios from "axios";
import { toast } from "react-toastify";

/* Create axios instance */
const api = axios.create();

/* Request counter */
let activeRequests = 0;

let toastId = null;

/* Show loader */
const showLoader = () => {
    if (activeRequests === 0) {
        document.getElementById("loading-indicator")?.classList.add("open");
    }
    activeRequests++;
}

/* Hide loader */
const hideLoader = () => {
    activeRequests = Math.max(0, activeRequests - 1);
    if (activeRequests === 0) {
        document.getElementById("loading-indicator")?.classList.remove("open");
    }
}

api.interceptors.request.use(
    (config) => {
        showLoader();
        return config;
    },
    (error) => {
        hideLoader();
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => {
        hideLoader();
        return response;
    },
    (error) => {
        hideLoader();

        const errMessage = error?.response?.data?.detail || "Системна грешка";
        const status = error?.response?.status;

        const handleClose = () => {
            if (status === 403) {
                sessionStorage.removeItem("token");
                window.location.reload();
            }
        };

        if (!toast.isActive(toastId)) {
            toastId = toast.error(errMessage, {
                autoClose: 2000,
                position: "top-right",
                bodyClassName: "styled-toaster",
                onClose: handleClose,
            });
        } else {
            toast.update(toastId, {
                render: errMessage,
                autoClose: 2000,
                position: "top-right",
                bodyClassName: "styled-toaster",
                onClose: handleClose,
            });
        }

        return Promise.reject(error);
    }
);

export async function fetchRequest(url, headers = {}, config) {
    const token = sessionStorage?.token || "";
    const isFormData = headers?.data instanceof FormData;

    const requestConfig = {
        url,
        method: config?.method || "GET",
        headers: {
            "Content-Type": isFormData ? "multipart/form-data" : "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...headers?.headers
        },
        responseType: config?.responseType || "json",
        ...headers
    };

    try {
        const response = await api(requestConfig);
        return response.data;
    } catch (error) {
        throw error;
    }
}
